import { render } from "./rough_view.vue?vue&type=template&id=4c4be831"
import script from "./rough_view.vue?vue&type=script&lang=js"
export * from "./rough_view.vue?vue&type=script&lang=js"

import exportComponent from "D:\\shiv_mfg_front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__